import React from 'react';
import type { OnboardingSummary } from '../../../types/onboarding';
import useOnboardingSummary from '../../../hooks/useOnboardingSummary';
import Tower from '../../../assets/images/tower.svg';
import Chat from '../../../assets/images/chat.svg';

interface IdealConnectionSectionProps {
  section: OnboardingSummary;
}

const IdealConnectionSection = (props: IdealConnectionSectionProps) => {
  const { section } = props;

  const { introductionPacing, communicationStyle } = useOnboardingSummary({
    section,
  });

  return (
    <div>
      <div className='md:grid grid-cols-2 gap-6'>
        <div>
          <div className='font-bold text-body-400 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={Tower}
              alt='Introduction pacing'
            />
            Introduction pacing:
          </div>
          <p className='text-lg mb-7'>{introductionPacing}</p>
        </div>
        <div>
          <div className='font-bold text-body-400 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={Chat}
              alt='Communication style'
            />
            Communication style:
          </div>
          <p className='text-lg mb-7'>{communicationStyle}</p>
        </div>
      </div>
    </div>
  );
};

export default IdealConnectionSection;
